import React from "react";
import StatsNavTab from "./StatsNavTab";
import StatsTableItem from "./StatsTableItem";

const Stats = () => {
    const tableItems = [ 1,2,3,4,5];
    return (
        <div className="_creator_top_wrap">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <div className="_stats_title_wrap">
                            <h2 className="_creator_title">Activity</h2>
                            <p className="_creator_txt">The top NFTs on mxama, ranked by volume, floor price and other
                                statistics</p>
                        </div>
                    </div>
                </div>
                <div className="_stats_main_wrapper">
                    <div className="row">
                        <StatsNavTab/>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="_nft_settings_main_bottom_body">
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pillsonsale" role="tabpanel"
                                        aria-labelledby="pills-home-tab">
                                        <div className="row my-3">
                                            {
                                                tableItems.map((item,id)=><StatsTableItem/>)
                                            }
                                        </div>
                                        <div className="row my-3">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <div className="_load_more_btn_wrap text-center">
                                                    <button className="_stat_item_load_btn">
                                                        Load More
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="followingtab" role="tabpanel"
                                        aria-labelledby="pillscreatedtab">Following</div>
                                    <div className="tab-pane fade" id="myactivity" role="tabpanel"
                                        aria-labelledby="pills-contact-tab">My activity</div>
                                    <div className="tab-pane fade" id="mybids" role="tabpanel"
                                        aria-labelledby="pills-contact-tab">My bids</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Stats;